import React from "react";
import { IconButton } from "@mui/material";
import { ModeEditOutlineTwoTone } from "@mui/icons-material";

import UserEntityAccessForm from "./UserEntityAccessForm";
import AppTable from "components/Shared/AppTable/AppTable";
import FormDrawer from "components/Shared/FormDrawer";

import { useAuth } from "hooks/useAuth";
import { useUserDetail } from "../UserDetailScreen";

const UserEntitiesAndAccess = () => {
  const [selectedEntity, setSelectedEntity] = React.useState(null);

  const { isAccountAdmin, isSystemAdmin } = useAuth();

  const { userDetail } = useUserDetail();

  const userEntities = userDetail?.entities ?? [];

  const disableEntityChange = ["Client", "Referral"].includes(
    userDetail?.typeRefSource
  );

  const columns = [
    {
      name: "Entity",
      selector: (row) => row?.entity?.displayName ?? row?.entity?.name,
    },
    {
      name: "Authorizations",
      cell: (row) => (
        <div className="flex flex-col gap-2 py-2">
          {row?.authorizations.map((auth) => (
            <li key={auth._id} className="list-disc">
              {auth.role}
            </li>
          )) ?? "N/A"}
        </div>
      ),
    },
    {
      name: "Default Authorization",
      cell: (row) => row?.defaultAuthorization?.role,
    },
    {
      name: "Status",
      cell: (row) => (
        <div className={row?.isActive ? "text-green-500" : "text-red-500"}>
          {row?.isActive ? "Active" : "Inactive"}
        </div>
      ),
    },
    ...(isAccountAdmin || isSystemAdmin
      ? [
          {
            name: "Actions",
            cell: (row) => (
              <IconButton
                size="small"
                aria-label="Edit Lead"
                onClick={() => setSelectedEntity(row)}
              >
                <ModeEditOutlineTwoTone />
              </IconButton>
            ),
            ignoreRowClick: true,
            right: true,
          },
        ]
      : []),
  ];

  if (!userDetail?.isActive) return null;

  return (
    <>
      <FormDrawer
        title="User Entity Access"
        open={!!selectedEntity}
        onCancel={() => setSelectedEntity(null)}
      >
        <UserEntityAccessForm
          userEntity={selectedEntity}
          onCancel={() => setSelectedEntity(null)}
          {...{ disableEntityChange }}
        />
      </FormDrawer>

      <AppTable columns={columns} data={userEntities} />
    </>
  );
};

export default UserEntitiesAndAccess;
